import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom bg-[#23242A]" }
const _hoisted_2 = {
  key: 0,
  class: "flex xl:flex-row flex-col px-4 pt-4 bg-[#23242A] text-white"
}
const _hoisted_3 = {
  key: 0,
  class: "xl:w-[60%] w-full custom-right transition-all duration-100 ease-linear"
}
const _hoisted_4 = {
  key: 1,
  class: "p-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_list = _resolveComponent("product-list")!
  const _component_edit_product = _resolveComponent("edit-product")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.vg_selectedLocation.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["transition-all duration-100 ease-linear custom-left mr-2", _ctx.edit.modal?'xl:w-[40%] w-full':'w-full'])
          }, [
            _createVNode(_component_product_list, {
              payload: _ctx.listType.data,
              resized: _ctx.edit.modal,
              onToggleEdit: _ctx.toggleEdit
            }, null, 8, ["payload", "resized", "onToggleEdit"])
          ], 2),
          (_ctx.edit.modal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.edit.modal)
                  ? (_openBlock(), _createBlock(_component_edit_product, {
                      key: 0,
                      editItem: _ctx.edit.data,
                      inventory: true,
                      onClose: _ctx.closeEdit
                    }, null, 8, ["editItem", "onClose"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl" }, [
            _createElementVNode("div", { class: "w-full" }, [
              _createElementVNode("div", { class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]" }, [
                _createElementVNode("p", { class: "text-center text-theme-red" }, "Please select a location from the top left corner.")
              ])
            ])
          ], -1)
        ]))]))
  ]))
}